import axios from "axios";
import { getFingerprint } from '@thumbmarkjs/thumbmarkjs';

const baseURL = "https://api3.vault56.com/v2";

export async function v56a_checkTokenValidity() {
    let response = await axios.get(baseURL + '/auth/checkauth', {
        params: {
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }
    }).catch(() => {
        return false;
    });

    return response.status === 200;
}

export function v56a_logout() {
    localStorage.removeItem('v56_token');
    localStorage.removeItem('v56_secret');
    localStorage.removeItem('v56_session');
    window.location.href = 'https://secure.vault56.com';
}

export async function v56a_getContactInfo() {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/contact/info', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        });
    }
}

export async function v56a_activateModuleTrial(moduleName) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/contact/module/trial/' + moduleName, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        });
    }
}

export async function v56a_getAccount(accountId) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/account/' + accountId, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        });
    }
}

/*
export async function v56a_s3_getBuckets() {
    const s3 = new AWS.S3({
        accessKeyId: "aJFdvkxNbWHZYu4O",
        region: 'us-east-1',
        secretAccessKey: "MNlEPClS8jHfj1ptaqNt0aQupJEDMbZL",
        endpoint: "http://b1.jl-systems.se:9000",
        s3ForcePathStyle: true,
        signatureVersion: "v4"
    });

    s3.config.update({correctClockSkew: true});

    await s3.listObjects({Bucket: "vault56"}, (err, data) => {
        if (err === null) {
            return data.Contents;
        }

        return err; // Should we return false and log the error instead?
    });
}
*/

export async function v56a_getContactSetting(setting_name, contact_id) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/contact/' + contact_id + '/setting', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                setting_name: setting_name,
                fingerprint: await getFingerprint()
            }
        });
    }
}

export async function v56a_getAccountSetting(setting_name, account_id) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/account/' + account_id + '/setting', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                setting_name: setting_name,
                fingerprint: await getFingerprint()
            }
        }).catch(() => {
            return false;
        });
    }
}

export async function v56a_getAddress(address_id) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/account/address/' + address_id, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        });
    }
}

export async function v56a_deleteFile(file_id) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/file/' + file_id + '?' +
            params;

        return await axios.delete(url, {
        }).catch(() => {
            return false;
        });
    }
}

export async function v56a_deleteBucketUser(user_id) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/bucket/user/' + user_id + '?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('user_id', user_id);

        return await axios.post(url, bodyFormData, {
            Headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
            },
            data: bodyFormData
        }).catch(() => {
            return false;
        });
    }
}

export async function v56a_getCountries() {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/country', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        });
    }
}

export async function v56a_getModules(moduleAccessOnly=false) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/contact/module', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                module_access_only: moduleAccessOnly,
                fingerprint: await getFingerprint()
            }
        });
    }
}

/**
 * Activates or deactivates subscription for an already activated (paid for) module
 * @param moduleName
 * @param operation
 * @returns AxiosResponse
 */
export async function v56a_getActivateDeactivateModule(moduleName, operation) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/contact/module/' + moduleName + '/subscription/' + operation, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        });
    }
}

export async function v56a_getTrialMode(module) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/auth/trial_mode', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                module: module,
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export async function v56a_getBuckets() {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/bucket', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export async function v56a_getAssets() {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/asset', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export async function v56a_getProfiles() {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/profile', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export async function v56a_saveVDriveProfile(id=null, profile_name, properties) {
    // Make sure properties is of type object
    if (typeof properties !== 'object') {
        properties = JSON.parse(properties);
    }
    if (await v56a_checkTokenValidity()) {
        return await axios.post(baseURL + '/profile' + (id!==null?'/' + id:''), {
            profile_name: profile_name,
            properties: JSON.stringify(properties)
        }, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}


export function getJsonFieldValue(json, field, defaultValue) {
    if (field in JSON.parse(json))
    {
        return JSON.parse(json)[field]
    }
    return defaultValue;
}

export async function v56a_saveAsset(properties) {
    // Make sure properties is of type object
    if (typeof properties !== 'object') {
        properties = JSON.parse(properties);
    }
    if (await v56a_checkTokenValidity()) {
        return await axios.post(baseURL + '/asset', {
            properties: JSON.stringify(properties)
        }, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export async function v56a_deleteAsset(id) {
    if (await v56a_checkTokenValidity()) {
        return await axios.delete(baseURL + '/asset/' + id, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export async function v56a_updateAsset(id, properties) {
    // Make sure properties is of type object
    if (typeof properties !== 'object') {
        properties = JSON.parse(properties);
    }
    if (await v56a_checkTokenValidity()) {
        return await axios.put(baseURL + '/asset/' + id, {
            properties: JSON.stringify(properties)
        }, {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

export function v56_setJsonValue(existingArray, key, value) {
    // Make sure existingArray is of type object
    if (typeof existingArray !== 'object') {
        existingArray = JSON.parse(existingArray);
    }
    existingArray[key] = value;
    return existingArray;
}

export function v56_getJsonValue(existingArray, key) {
    // Make sure existingArray is of type object
    if (typeof existingArray !== 'object') {
        existingArray = JSON.parse(existingArray);
    }
    // Make sure this value exist
    if (!(key in existingArray)) {
        return '';
    }
    return existingArray[key];
}

/**
 * Get files in a bucket
 * @param parentBucket
 * @param parentCategory
 * @returns AxiosResponse
 */
export async function v56a_getFiles(parentBucket, parentCategory = null) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/file', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint(),
                file_category: (parentCategory !== null ? parentCategory : 'null'),
                parent_object: 'bucket',
                parent_object_id: parentBucket
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

/**
 * Get folders in a bucket
 * @param parentBucket
 * @param parentCategory
 * @returns AxiosResponse
 */
export async function v56a_getFolders(parentBucket, parentCategory = null) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/file/category', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint(),
                parent_file_category: (parentCategory !== null ? parentCategory : 'null'),
                parent_object: 'bucket',
                parent_object_id: parentBucket
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

/**
 * Gets bytes downloaded per hour
 * @returns AxiosResponse
 */
export async function v56a_getBytesPerHour(operation='put', fromDate=null, toDate=null) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/file/report/bytes_per_hour', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint(),
                operation: operation,
                fromDate: fromDate,
                toDate: toDate
            }
        }).catch((err) => {
            return err.response;
        });
    }
}


/**
 * Gets a list of bucket users for a given bucket.
 * @param bucket_name
 * @returns AxiosResponse
 */
export async function v56a_getBucketUsers(bucket_name) {
    if (await v56a_checkTokenValidity()) {
        return await axios.get(baseURL + '/bucket/' + bucket_name + '/user', {
            params: {
                token: localStorage.getItem('v56_token'),
                secret: localStorage.getItem('v56_secret'),
                fingerprint: await getFingerprint()
            }
        }).catch((err) => {
            return err.response;
        });
    }
}

/**
 * Creates a new presigned upload URL for a given bucket.
 * @param file_name
 * @param access_key_id
 * @param bucket_id
 * @returns AxiosResponse
 */
export async function v56a_createUploadUrl(file_name, access_key_id, bucket_id) {
    if (await v56a_checkTokenValidity()) {
        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/file/s3/upload?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('file_name', file_name);
        bodyFormData.append('access_key_id', access_key_id);
        bodyFormData.append('bucket_id', bucket_id);

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

/**
 * Creates a new pre-signed download URL for a given bucket and file.
 * @param file_id
 * @param bucket_id
 * @returns AxiosResponse
 */
export async function v56a_createDownloadUrl(file_id, bucket_id) {
    if (await v56a_checkTokenValidity()) {
        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/file/s3/download?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('file_id', file_id);
        bodyFormData.append('bucket_id', bucket_id);

        return await axios
            .post(url, bodyFormData, {
                Headers: {},
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

/**
 * Creates a new folder in a given bucket.
 * @param folderName
 * @param bucketId
 * @param parentCategory
 * @returns AxiosResponse
 */
export async function v56a_createFolder(folderName, bucketId, parentCategory = null) {
    if (await v56a_checkTokenValidity()) {
        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/file/category?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('category_name', folderName);
        if (parentCategory !== null) {
            bodyFormData.append('parent', '{"bucket": "' + bucketId + '", "file_category": "' + parentCategory + '"}');
        } else {
            bodyFormData.append('parent', '{"bucket": "' + bucketId + '"}');
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {},
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

/**
 * Deletes a folder with given ID.
 * @param folderId
 * @returns AxiosResponse
 */
export async function v56a_deleteFolder(folderId) {
    if (await v56a_checkTokenValidity()) {
        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/file/category/' + folderId + '?' +
            params;

        return await axios
            .delete(url, {
                Headers: {}
            }).catch((err) => {
                return err.response;
            });
    }
}

/**
 * Creates a new user for given bucket. Returns a named array in format [username, password].
 * @param bucket_name
 * @returns AxiosResponse
 */
export async function v56a_createBucketUser(bucket_name) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/bucket/' + bucket_name + '/user?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('bucket_name', bucket_name);

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

export async function v56a_createBucket(bucket_name, bucket_description, versioning, ransomware_protection, ransomware_protection_days, quota, quota_limit, quota_type, properties) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/bucket?' +
            params;

        // Make sure properties is of type object
        if (typeof properties !== 'object') {
            properties = JSON.parse(properties);
        }

        const bodyFormData = new FormData();
        bodyFormData.append('bucket_name', bucket_name);
        bodyFormData.append('bucket_description', bucket_description);
        bodyFormData.append('versioning', (versioning? 'true' : 'false'));
        bodyFormData.append('ransomware_protection', (ransomware_protection?'true':'false'));
        bodyFormData.append('ransomware_protection_days', ransomware_protection_days);
        bodyFormData.append('quota', (quota?'true':'false'));
        bodyFormData.append('quota_limit', quota_limit);
        bodyFormData.append('quota_type', quota_type);
        bodyFormData.append('properties', JSON.stringify(properties));

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

export async function v56a_saveAccessDescription(user_id, bucket_id, description) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/bucket/' + bucket_id + '/user/' + user_id + '?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('description', description);

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

export async function v56a_saveBucket(bucket_id, bucket_name, bucket_description, versioning, ransomware_protection_days, quota, quota_limit, quota_type, properties) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/bucket/' + bucket_id + '?' +
            params;

        // Make sure properties is of type object
        if (typeof properties !== 'object') {
            properties = JSON.parse(properties);
        }

        const bodyFormData = new FormData();
        bodyFormData.append('bucket_name', bucket_name);
        bodyFormData.append('bucket_description', bucket_description);
        bodyFormData.append('versioning', (versioning? 'true' : 'false'));
        bodyFormData.append('ransomware_protection_days', ransomware_protection_days);
        bodyFormData.append('quota', (quota?'true':'false'));
        bodyFormData.append('quota_limit', quota_limit);
        bodyFormData.append('quota_type', quota_type);
        bodyFormData.append('properties', JSON.stringify(properties));

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            }).catch((err) => {
                return err.response;
            });
    }
}

export async function v56a_setContactSetting(setting_name, setting_value, contact_id) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/contact/' + contact_id + '/setting?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('setting_name', setting_name);
        bodyFormData.append('setting_value', setting_value);

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_setAccountSetting(setting_name, setting_value, account_id) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/account/' + account_id + '/setting?' +
            params;

        const bodyFormData = new FormData();
        bodyFormData.append('setting_name', setting_name);
        bodyFormData.append('setting_value', setting_value);

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_putAccount(
    account_id ,
    account_name = null,
    vat_id = null,
    primary_address = null,
    primary_invoice_email = null,
    person_account = null,
    person_account_contact = null
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/account/' + account_id + '?' +
            params;

        const bodyFormData = new FormData();

        if (account_name !== null) {
            bodyFormData.append('account_name', account_name);
        }
        if (vat_id !== null) {
            bodyFormData.append('vat_id', vat_id);
        }
        if (primary_address !== null) {
            bodyFormData.append('primary_address', primary_address);
        }
        if (primary_invoice_email !== null) {
            bodyFormData.append('primary_invoice_email', primary_invoice_email);
        }
        if (person_account !== null) {
            bodyFormData.append('person_account', person_account);
        }
        if (person_account_contact !== null) {
            bodyFormData.append('person_account_contact', person_account_contact);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_putContact(
    contact_id ,
    first_name = null,
    middle_name = null,
    last_name = null,
    is_portal_user = null,
    parent_account = null,
    primary_phone = null,
    primary_email = null,
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/contact/' + contact_id + '?' +
            params;

        const bodyFormData = new FormData();

        if (first_name !== null) {
            bodyFormData.append('first_name', first_name);
        }
        if (middle_name !== null) {
            bodyFormData.append('middle_name', middle_name);
        }
        if (last_name !== null) {
            bodyFormData.append('last_name', last_name);
        }
        if (is_portal_user !== null) {
            bodyFormData.append('is_portal_user', is_portal_user);
        }
        if (parent_account !== null) {
            bodyFormData.append('parent_account', parent_account);
        }
        if (primary_phone !== null) {
            bodyFormData.append('primary_phone', primary_phone);
        }
        if (primary_email !== null) {
            bodyFormData.append('primary_email', primary_email);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_postAccountEmailAddress(
    account_id,
    email,
    email_category = null
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/account/email_address?' +
            params;

        const bodyFormData = new FormData();

        bodyFormData.append('parent', '{"account":"' + account_id + '"}');
        bodyFormData.append('email', email);
        if (email_category !== null) {
            bodyFormData.append('email_category', email_category);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_postContactPhone(
    contact_id,
    phone_no,
    phone_category = null
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/phone_number?' +
            params;

        const bodyFormData = new FormData();

        bodyFormData.append('parent', '{"contact":"' + contact_id + '"}');
        bodyFormData.append('phone_no', phone_no);
        if (phone_category !== null) {
            bodyFormData.append('phone_category', phone_category);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_putContactPhone(
    contact_id,
    phone_number_id,
    phone_no = null,
    phone_category = null
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/phone_number/'+phone_number_id+'?' +
            params;

        const bodyFormData = new FormData();

        bodyFormData.append('parent', '{"contact":"' + contact_id + '"}');
        if (phone_no !== null) {
            bodyFormData.append('phone_no', phone_no);
        }
        bodyFormData.append('phone_no', phone_no);
        if (phone_category !== null) {
            bodyFormData.append('phone_category', phone_category);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_postAccountAddress(
    account_id,
    address = null,
    zip = null,
    city = null,
    state = null,
    country = null,
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/account/address?' +
            params;

        const bodyFormData = new FormData();

        bodyFormData.append('parent', '{"account":"' + account_id + '"}');
        if (address !== null) {
            bodyFormData.append('address', address);
        }
        if (zip !== null) {
            bodyFormData.append('zip', zip);
        }
        if (city !== null) {
            bodyFormData.append('city', city);
        }
        if (state !== null) {
            bodyFormData.append('state', state);
        }
        if (country !== null) {
            bodyFormData.append('country', country);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}

export async function v56a_putAccountAddress(
    account_id,
    address_id,
    address = null,
    zip = null,
    city = null,
    state = null,
    country = null,
) {
    if (await v56a_checkTokenValidity()) {

        const params = new URLSearchParams({
            token: localStorage.getItem('v56_token'),
            secret: localStorage.getItem('v56_secret'),
            fingerprint: await getFingerprint()
        }).toString();

        const url =
            baseURL + '/account/address/' + address_id + '?' +
            params;

        const bodyFormData = new FormData();

        bodyFormData.append('parent', '{"account":"' + account_id + '"}');
        if (address !== null) {
            bodyFormData.append('address', address);
        }
        if (zip !== null) {
            bodyFormData.append('zip', zip);
        }
        if (city !== null) {
            bodyFormData.append('city', city);
        }
        if (state !== null) {
            bodyFormData.append('state', state);
        }
        if (country !== null) {
            bodyFormData.append('country', country);
        }

        return await axios
            .post(url, bodyFormData, {
                Headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
                },
                data: bodyFormData
            });
    }
}
